var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-carousel',{attrs:{"id":"carousel-1","interval":4000,"controls":""}},_vm._l((_vm.images),function(image,key){return _c('b-carousel-slide',{key:key,attrs:{"img-src":image}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }